import React from 'react';
import { Grid, TextField, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { partial, times } from 'lodash';
import RubricBlock from '@dyl/blocks/RubricBlock';
import SectionDividers from '@dyl/components/SectionDividers';
import useChangeEvent from '@dyl/hooks/useChangeEvent';
import useTaskField from '@dyl/pages/Tasks/edit/useTaskField';
import TaskRadioTextBlock from '@dyl/blocks/TaskRadioTextBlock';

const useStyles = makeStyles(theme => ({
    root: {
        maxWidth: theme.breakpoints.values.md,
    },
}));

export default function InformationTextEditor() {
    const classes = useStyles();
    const [items] = useTaskField('items');

    return (
        <div className={classes.root}>
            <SectionDividers>
                {times(items.length, i =>
                    <Item
                        key={i}
                        index={i}
                    />)}
            </SectionDividers>
        </div>
    );
}

function Item({ index }) {
    const isExample = index === 0;
    const useField = partial(useTaskField, 'items', index);

    const [text1, setText1, text1Error] = useField('stimulus_text_1');
    const [text2, setText2, text2Error] = useField('stimulus_text_2');
    const onText1Change = useChangeEvent(setText1);
    const onText2Change = useChangeEvent(setText2);

    return (
        <>
            <Typography variant='h6'>
                {isExample ? 'Example' : `Item ${index}`}
            </Typography>

            {isExample && (
                <RubricBlock />
            )}

            <Grid container spacing={2} style={{ marginTop: '12px' }}>

                <Grid item xs={12} md={6}>
                    <TextField
                        label='Stimulus Text 1'
                        value={text1}
                        onChange={onText1Change}
                        variant='filled'
                        fullWidth
                        helperText={text1Error || ' '}
                        error={!!text1Error}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <TextField
                        label='Stimulus Text 2'
                        value={text2}
                        onChange={onText2Change}
                        variant='filled'
                        fullWidth
                        helperText={text2Error || ' '}
                        error={!!text2Error}
                    />
                </Grid>

                <Grid item md={12}></Grid>
            </Grid>

            <TaskRadioTextBlock path={['items', index, 'answers']}/>

        </>
    );
}